/** Keeps only the newest asynchronous browser response eligible to update state. */
export interface LatestRequestGate {
  begin(): number
  isCurrent(request: number): boolean
  invalidate(): void
}

export function createLatestRequestGate(): LatestRequestGate {
  let current = 0
  return {
    begin: () => {
      current += 1
      return current
    },
    isCurrent: (request) => request === current,
    invalidate: () => { current += 1 },
  }
}
